import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const FunnelIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 21.5 25.166"
    >
      <g transform="translate(0.75 0.75)">
        <ellipse
          cx="10"
          cy="3.359"
          rx="10"
          ry="3.359"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="7.251"
          y2="11.643"
          transform="translate(12.409 4.312)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          transform="translate(12.409 15.955)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="7.251"
          y1="11.607"
          transform="translate(0.339 4.312)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M261.949,18.2v6.019a1.734,1.734,0,0,0,1.729,1.728h1.361a1.734,1.734,0,0,0,1.729-1.728V18.238"
          transform="translate(-254.359 -2.284)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
